export const MODEL_CATEGORIES = ['chat', 'decisions', 'tts', 'stt'];
export function modelCategory(modality) {
  const outputs = modality?.output ?? [];
  return outputs.includes('speech') ? 'tts' : outputs.includes('transcription') ? 'stt' : outputs.includes('decisions') ? 'decisions' : outputs.includes('text') ? 'chat' : null;
}
export function formatPrice(value) {
  if (value == null || !Number.isFinite(value) || value < 0) return '—';
  return `$${Number(value.toPrecision(6)).toString()}`;
}
export function catalogRow(it) {
  return {
    audioRates: it.audioRates,
    id: it.id, vendor: it.vendor, modality: it.modality, category: modelCategory(it.modality),
    bestIn: it.bestInputPer1M ?? null, bestOut: it.bestOutputPer1M ?? null,
    pricingMode: it.pricingMode, bestUpstream: it.audioUpstream ?? it.bestUpstream,
    official: { in: it.openrouterInputPer1M ?? null, out: it.openrouterOutputPer1M ?? null },
    upstreams: (it.providers ?? []).map(p => ({ audioRates:p.audioRates, referencePrices:p.referencePrices, name: p.name, in: p.inputPer1M ?? null, out: p.outputPer1M ?? null })),
    providerCount: it.providerCount ?? 0, calls: it.calls ?? 0, tokens: it.tokens ?? 0,
  };
}

/** Fetch every page so a newly synced category is searchable even after the first 200 entries. */
export async function loadModelCatalog(fetchPage, cancelled = () => false) {
  const items = [], limit = 200;
  while (!cancelled()) {
    const page = await fetchPage({ window: '30d', limit, offset: items.length });
    if (!Array.isArray(page?.items)) throw new Error('Invalid model catalog');
    items.push(...page.items);
    if (page.total == null || items.length >= page.total) return items;
    if (!page.items.length) throw new Error('Incomplete model catalog');
  }
  return [];
}
